import React, { useEffect } from "react";
import Navegacion from "../components/Navegacion";
import { Outlet, useLocation } from "react-router-dom";

const LayoutNoVerificado = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <>
      <Navegacion isVerificado={false} />
      <Outlet />
    </>
  );
};

export default LayoutNoVerificado;
